import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { TextEllipsis } from 'components/Kizen/Table';
import { shadowOverlay } from 'app/colors';

const TrayButtonWrapper = styled.button`
  width: 100%;
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  grid-column: span ${({ cols }) => cols};
  background: var(--color-background-white);
  border: 1px solid var(--color-border-medium);
  ${shadowOverlay}
  color: var(--color-font-primary);
  ${({ hoverColor }) => css`
    &:hover {
      color: ${hoverColor};
      border-color: ${hoverColor};
    }
  `}
  &:focus {
    outline: none;
  }
  > :first-child {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  > :last-child {
    margin-bottom: 2.6px;
  }
`;

export const TrayButton = ({
  image,
  label,
  hoverColor = 'var(--color-button-secondary-hover)',
  cols = 1,
  ...others
}) => {
  return (
    <TrayButtonWrapper hoverColor={hoverColor} cols={cols} {...others}>
      <span>{image}</span>
      <TextEllipsis as="span" size="small" weight="bold" color="inherit">
        {label}
      </TextEllipsis>
    </TrayButtonWrapper>
  );
};
